<template>
  <section v-show="isActive" class="tabs__accordion-section">
    <div :class="{ 'tabs__accordion-content--is-active': isActive }" class="tabs__accordion-content">
      <slot></slot>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    displayName: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isActive: false
  }),
  watch: {
    selected(newVal) {
      this.isActive = newVal
    }
  },
  mounted() {
    this.isActive = this.selected
  }
}
</script>
